"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PhoneNumberGeneralHandler", {
    enumerable: true,
    get: function() {
        return PhoneNumberGeneralHandler;
    }
});
const _longtextgeneralhandler = require("../long-text/long-text.general.handler");
let PhoneNumberGeneralHandler = class PhoneNumberGeneralHandler extends _longtextgeneralhandler.LongTextGeneralHandler {
};
